export const PAGE_CREATE = 'PAGE_CREATE'
export const PAGE_EDIT = 'PAGE_EDIT'
export const PAGE_REVIEW = 'PAGE_REVIEW'
export const PAGE_DIFF = 'PAGE_DIFF'
export const PAGE_DETAIL = 'PAGE_DETAIL'
export const PAGE_RESERVE = 'PAGE_RESERVE'
export const PAGE_OGP = 'PAGE_OGP'


